import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LanguageDropdownComponent } from 'src/app/components/language-dropdown/language-dropdown.component';

@Component({
  selector: 'app-login-layout',
  imports: [LanguageDropdownComponent, RouterModule],
  templateUrl: './login-layout.component.html',
  styleUrl: './login-layout.component.scss'
})
export class LoginLayoutComponent {}
